module.exports = __webpack_public_path__ + "static/media/message.1349a5e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/message.svg
// module id = 245
// module chunks = 1